import { createWebHistory, createRouter } from 'vue-router';
import AuthenticateOIDC from '@/pages/AuthenticateOIDC.vue';
import Login from '@/pages/login/Login.vue';
import ForgotPassword from '@/pages/login/ForgotPassword.vue';
import CompanyGivingOverview from '@/pages/companyGiving/overview/Overview.vue';
import CompanyGivingRegistration from '@/pages/companyGiving/registration/Registration.vue';
import CompanyGivingInvited from '@/pages/companyGiving/registration/Invited.vue';
import CompanyGivingProfile from '@/pages/companyGiving/profile/Profile.vue';
import EmployeeGiving from '@/pages/companyGiving/employeeGiving/EmployeeGiving.vue';
import MyPublicPage from '@/pages/companyGiving/myPublicPage/MyPublicPage.vue';
import CompanyGivingSettings from '@/pages/companyGiving/settings/Settings.vue';
import CompanyGivingMyPublicPage from '@/pages/companyGiving/myPublicPage/MyPublicPage.vue';
import CompanyGivingFeaturedCauses from '@/pages/companyGiving/featuredCauses/FeaturedCauses.vue';
import AuthGuard from './auth-guard';
import Overview from '@/pages/donorAccount/overview/Overview.vue';
import DonationHistory from '@/pages/donorAccount/donationHistory/DonationHistory.vue';
import Fundraisers from '@/pages/donorAccount/fundraisers/Fundraisers.vue';
import FavoriteCauses from '@/pages/donorAccount/favoriteCauses/FavoriteCauses.vue';
import Settings from '@/pages/donorAccount/settings/Settings.vue';
import SidebarNav from '@/pages/SidebarNav.vue';
import FundraiserDetails from '@/pages/donorAccount/fundraisers/FundraiserDetails.vue';
import Forbidden from '@/pages/Forbidden.vue';
import NotFound from '@/pages/NotFound.vue';
import CandidAPI from '@/pages/CandidAPI.vue';
import CompanyGivingFundraisers from '@/pages/companyGiving/fundraisers/Fundraisers.vue';
import CompanyGivingFundraiserDetails from '@/pages/companyGiving/fundraisers/FundraiserDetails.vue';

// import CheckUncommittedChanges from "./check-uncommitted-changes";
// import CheckUncommittedThemes from "./check-uncommitted-themes";

const routes = [
  {
    path: '/authenticate',
    name: 'AuthenticateOIDC',
    component: AuthenticateOIDC,
  },
  {
    path: '/login',
    name: 'Login',
    component: Login,
    meta: { noLoader: true },
  },
  {
    path: '/logout',
    name: 'Logout',
    component: Login,
    meta: { noLoader: true },
  },
  {
    path: '/candid-api',
    name: 'CandidAPI',
    component: CandidAPI,
    meta: { noLoader: true },
  },
  {
    path: '/forgot-password',
    name: 'ForgotPassword',
    component: ForgotPassword,
    meta: { noLoader: true },
  },
  {
    path: '/403',
    name: 'Forbidden',
    component: Forbidden,
    meta: { noLoader: true },
  },
  {
    path: '/company/registration',
    name: 'CompanyGivingRegistration',
    component: CompanyGivingRegistration,
    meta: { noLoader: true },
  },
  {
    path: '/company/profile',
    name: 'CompanyGivingProfile',
    component: CompanyGivingProfile,
    meta: { noLoader: true },
  },
  {
    path: '/company/join',
    name: 'CompanyGivingInvited',
    component: CompanyGivingInvited,
    meta: { noLoader: true },
  },
  {
    path: '/',
    name: 'App',
    beforeEnter: AuthGuard,
    component: SidebarNav,
    meta: { accountType: 'donorAccount' },
    children: [
      {
        path: '/',
        name: 'Overview',
        component: Overview,
      },
      {
        path: 'donationHistory',
        name: 'DonationHistory',
        component: DonationHistory,
      },
      {
        path: 'fundraisers',
        name: 'Fundraisers',
        component: Fundraisers,
        params: true,
      },
      {
        path: 'favoriteCauses',
        name: 'FavoriteCauses',
        component: FavoriteCauses,
      },
      {
        path: 'settings',
        name: 'Settings',
        component: Settings,
      },
      {
        path: 'fundraisers/:idOrName',
        name: 'FundraiserDetails',
        component: FundraiserDetails,
        children: [
          {
            path: 'edit',
            name: 'EditFundraiser',
            component: FundraiserDetails,
            meta: { edit: true },
          },
        ],
      },
    ],
  },
  {
    path: '/company',
    name: 'CompanyGivingAdmin',
    beforeEnter: AuthGuard,
    component: SidebarNav,
    meta: { accountType: 'companyAccount' },
    children: [
      {
        path: 'overview',
        name: 'CompanyOverview',
        component: CompanyGivingOverview,
      },
      {
        path: 'employee-giving',
        name: 'EmployeeGiving',
        component: EmployeeGiving,
      },
      {
        path: 'fundraisers',
        name: 'CompanyGivingFundraisers',
        component: CompanyGivingFundraisers,
      },
      {
        path: 'public-page',
        name: 'CompanyPublicPage',
        component: CompanyGivingMyPublicPage,
      },
      {
        path: 'settings',
        name: 'CompanySettings',
        component: CompanyGivingSettings,
      },
      {
        path: 'featured-causes',
        name: 'CompanyFeaturedCauses',
        component: CompanyGivingFeaturedCauses,
      },
      {
        path: 'fundraisers/:idOrName',
        name: 'CompanyGivingFundraiserDetails',
        component: CompanyGivingFundraiserDetails,
        children: [
          {
            path: 'edit',
            name: 'EditCompanyGivingFundraiser',
            component: CompanyGivingFundraiserDetails,
            meta: { edit: true },
          },
        ],
      },
      
    ],
  },
  {
    path: '/index.php',
    name: 'InterceptLogin',
    beforeEnter: (to, from, next) => {
      const { section, action, autologinKey, code, state } = to.query;

      // Redirect https://donorportal.[domain]/index.php?action=inquiry to https://portal.[domain]/index.php?action=login_inquiry
      if (action === 'inquiry') {
        // Parse our current URL; replace the action with login_inquiry
        const newUrl = new URL(window.location.href);
        newUrl.searchParams.set('action', 'login_inquiry');

        // Replace donorportal with portal in domain
        const domain = newUrl.hostname.split('.');
        if (domain.length > 2) {
          domain[0] = 'portal';
        }
        newUrl.hostname = domain.join('.');

        // Redirect to the new URL
        window.location.replace(newUrl.href);
        return;
      }

      // Check for the forgot password scenario
      if (section === 'myAccount.donorAccounts' && action === 'view' && autologinKey) {
        next({
          path: '/forgot-password',
          query: { key: autologinKey },
        });
      }
      // Existing authentication interception
      else if (code && state) {
        next({
          path: '/authenticate',
          query: { code, state },
        });
      }
      // Default to login if no specific conditions are met
      else {
        next('/login');
      }
    },
  },
  {
    path: '/:pathMatch(.*)*',
    name: 'NotFound',
    component: NotFound,
    meta: { noLoader: true },
  },
];

const router = createRouter({
  history: createWebHistory('/'),
  routes,
});

// router.beforeEach((to, from, next) => {

//   // check if the route requires authentication
//   if (to.matched.some((record) => record.meta.requiresAuth)) {
//     console.log(1);
//     // check if there is a JWT token in local storage
//     const token = localStorage.getItem("token");
//     console.log(token);
//     if (!token) {
//       // if there is no token, redirect to login page
//       next("/login");
//     } else {
//       next();
//     }
//   } else {
//     // if the route does not require authentication, allow access to the route
//     next();
//   }
// });

// router.beforeEach(CheckUncommittedChanges);
// router.beforeEach(CheckUncommittedThemes);
// router.beforeEach(CheckUncommittedChanges);
// router.beforeEach(CheckUncommittedThemes);

export default router;
